<template>
<div>
    <!-- Modal -->
    <div id="openResourceImageAddModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-lg">Add images</h4>
                    <button type="button" dusk="modal-close-button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal">close
                    </button>
                </div>
                <div class="modal-body">
                    <div class="w-1/4 mr-4 hidden lg:inline">
                        <file-pond
                            name="test"
                            ref="pondResourceImage"
                            label-idle="Drop multiple files here..."
                            allow-multiple="true"
                            :server="resourceServer"
                            :onprocessfile="handleOnProcessResourceFile"
                            :onaddfilestart="handleOnAddFileStart"
                            dropOnPage="true"
                            dropOnElement="false"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex">

        <div class="col-9">
            <div class="flex items-baseline w-full mb-4">
                <h4 v-if="!editName" class="mr-2">{{ tempSection.name }}</h4>
                <input v-else v-model="tempSection.name" class="mr-2 form-control col-3">
                <a v-if="!editName" href="#" @click="editName = true">Edit</a>
            </div>
            <div class="flex items-start mb-4">
                <button class="btn btn-outline-primary rounded-full ml-2" @click="saveTitle">
                    Save
                </button>
            </div>

            <div class="card bg-white shadow">
                <div class="card-body text-center">
                    <file-pond :name="tempSection.name"
                               ref="pond"
                               :server="server"
                               :onprocessfile="handleOnProcessFile"
                               allowRevert="false"
                               class-name="my-pond"
                               label-idle="Drop or select an image with aspect ratio 16:9"
                               accepted-file-types="image/jpeg, image/png"
                               labelFileTypeNotAllowed="Invalid File Type"
                               fileValidateTypeLabelExpectedTypes="Only JPEG and PNG File Types Are Allowed."/>
                    <img width="600" v-if="tempSection.url" :src="tempSection.url">
                </div>
            </div>

            <div class="card bg-white shadow">
                <div class="card-body">
                    <div class="form-group">
                        <label class="font-bold tracking-wide">For Company</label>
                        <input v-if="section.company" v-model="section.company.name" class="form-control" disabled>
                        <input v-else class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label class="font-bold tracking-wide">For Contact Name</label>
                        <input v-if="section.companyContact" v-model="section.companyContact.name" class="form-control"
                               disabled>
                        <input v-else v-model="section.projectContact.name" class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label class="font-bold tracking-wide">For Contact Email</label>
                        <input v-if="section.companyContact" v-model="section.companyContact.email" class="form-control"
                               disabled>
                        <input v-else v-model="section.projectContact.email" class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label class="font-bold tracking-wide">For Contact Cell</label>
                        <input v-if="section.companyContact" v-model="section.companyContact.cell" class="form-control"
                               disabled>
                        <input v-else v-model="section.projectContact.cell" class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label class="font-bold tracking-wide">Created By Name</label>
                        <input v-model="section.createdBy.name" class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label class="font-bold tracking-wide">Created By Email</label>
                        <input v-model="section.createdBy.email" class="form-control" disabled>
                    </div>
                    <div class="form-group">
                        <label class="font-bold tracking-wide">Created By Phone</label>
                        <input v-model="section.createdBy.phone" class="form-control" disabled>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-3 preview pl-0">

            <div class="" style="padding: 0">
                <div>
                    <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">

                        <button @click="openResourceImageAddModal"
                                class="" style="color:white;">Photos +
                        </button>
                    </div>
                </div>
                <div class="col-md-12 overflow-hidden p-4" style="padding-left: 0 !important; padding-right: 0 !important;">
                    <div v-for="resourceImage in resourceFiles" >
                        <div class="col-md-4 resource-images-div">
                            <div class="resource-images">
                                <img :src="resourceImage.thumb_url">
                            </div>
                            <span class="resource-images-name">{{resourceImage.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overflow-hidden" style="padding: 0;margin-bottom: 20px;">
                <div>
                    <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">

                        <button
                            class="" style="color:white;">Tools
                        </button>
                    </div>
                </div>
                <div class="col-md-12 p-3" style="padding-left: 0 !important; padding-right: 0 !important;">
<!--                    <div @click="toolButton('addSignature', 'Contact Signature')" class="col-md-5 tool-buttons inline-block float-left">Contact Signature</div>-->
<!--                    <div @click="toolButton('addInitials', 'Contact Initials')" class="col-md-5 tool-buttons inline-block float-left">Contact Initials</div>-->
                    <div @click="toolButton('addDate', 'Add Date')" class="col-md-5 tool-buttons inline-block float-left">Add Date</div>
                    <div @click="toolButton('contactName', 'Contact Name')" class="col-md-5 tool-buttons inline-block float-left">Contact Name</div>
                    <div @click="toolButton('contactEmail', 'Contact Email')" class="col-md-5 tool-buttons inline-block float-left">Contact Email</div>
                    <div @click="toolButton('contactCompany', 'Contact Company')" class="col-md-5 tool-buttons inline-block float-left">Contact Company</div>
                    <div @click="toolButton('projectAddress', 'Project Address')" class="col-md-5 tool-buttons inline-block float-left">Project Address</div>
                    <div @click="toolButton('baseBid', 'Base Bid')" class="col-md-5 tool-buttons inline-block float-left">Base Bid</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import vueFilePond from 'vue-filepond';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
    import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
    import axios from "axios";
    import Form from "../../utils/form";
    import Swal from "sweetalert2";

    let token = document.head.querySelector('meta[name="csrf-token"]');
    const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginImageExifOrientation, FilePondPluginImageTransform);

    export default {
        props: ['section'],
        components: {FilePond},
        data() {
            return {
                resourceFiles: [],
                revertedResources: [],
                data_loading: false,
                hasOneFile: false,
                signatureButton: false,
                tempSection: {
                    id: this.section.id,
                    proposal_id: this.section.proposal_id,
                    name: this.section.name,
                    include_in_report: this.section.include_in_report,
                    order: this.section.order,
                    tag: this.section.tag,
                    deleteable: this.section.deleteable,
                    project: this.project,
                    company: this.company,
                    companyContact: this.companyContact,
                    createdBy: this.createdBy,
                    url: this.section.url,
                    path: this.section.path,
                    token: this.section.token,
                    template: this.section.template,
                    signature_section: this.section.signature_section,
                },
                signature: this.section.signature_section,
                editName: false,
                server: {
                    revert: (uniqueFileId, load, error) => {
                        axios.delete(route('proposal.delete-photo-title-section', {
                            proposal: this.tempSection.proposal_id,
                            proposalInspectionSection: this.tempSection.id,
                        }))
                            .catch((err) => error(err.response.message));
                        load();
                    },
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        formData.append('file', file, file.name);

                        const request = new XMLHttpRequest();
                        request.open('POST', '/proposal/' + this.section.proposal_id + '/proposal-title-section/' + this.tempSection.id + '/upload-photo');
                        request.setRequestHeader('X-CSRF-TOKEN', token.content);

                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = function () {
                            if (request.status >= 200 && request.status < 300) {
                                load(request.responseText);
                            } else {
                                error('oh no');
                            }
                        };
                        request.send(formData);
                    }
                },
                resourceServer: {
                    revert: (uniqueFileId, load, error) => {
                        let file = JSON.parse(uniqueFileId).resource;
                        this.revertedResources.push(file.token);
                        axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                            .catch((err) => error(err.response.message));
                        load();
                    },
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        // if (this.section.company) formData.append('company_id', this.section.company.id);
                        if (this.section.project.id) formData.append('project_id', this.section.project.id);
                        if (2) formData.append('directory_id', 2);
                        formData.append(fieldName, file, file.name);

                        const request = new XMLHttpRequest();
                        request.open('POST', '/api/proposal-resource-files');
                        request.setRequestHeader('X-CSRF-TOKEN', token.content);

                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = function () {
                            if (request.status >= 200 && request.status < 300) {
                                load(request.responseText);
                            } else {
                                error('oh no');
                            }
                        };

                        request.send(formData);
                        // window.location.reload();
                    }
                }
            }
        },
        mounted() {
            Bus.$on('signature', data => {
                this.tempSection.signature_section = data;
                this.signature = this.tempSection.signature_section;
            });

            Bus.$emit('signature', this.section.signature_section);

            Bus.$emit('showButton', { button: 'hideTemplate' });
            Bus.$emit('showButton', { button: 'hideSaveTemplate' });
        },
        created() {
            this.fetchData();
        },
        methods: {
            saveTitle() {
                this.editName = false;
                this.$emit('titleChanged', this.tempSection);
            },
            handleOnProcessFile(error, resourceFile) {
                this.tempSection = JSON.parse(resourceFile.serverId).section;
                this.saveTitle();
            },
            handleOnProcessResourceFile(error, resourceFile) {
                setTimeout(() => {
                    this.$refs.pondResourceImage.removeFile(resourceFile.id);
                    if (!resourceFile.serverId) return;
                    let file = JSON.parse(resourceFile.serverId).resource;
                    if (this.revertedResources.includes(file.token)) return;
                    file.thumb_url = route('resource-files.show-thumb', {resourceFile: file.token});
                    file.id_key = file.id;
                    this.resourceFiles.unshift(file);
                    this.hasOneFile = this.resourceFiles.length > 0;
                }, 2000);
            },
            handleOnAddFileStart() {
                this.hasOneFile = true;

            },
            async uploadFile() {
                let files = this.$refs.responsiveFileInput.files;
                if (files) {
                    let i = 0;
                    for (i; i < files.length; i++) {
                        const formData = new FormData();

                        // if (this.section.company) formData.append('company_id', this.section.company.id);
                        if (this.section.project.id) formData.append('project_id', this.section.project.id);
                        if (2)  formData.append('directory_id', 2)
                        formData.append('test', files[i]);
                        await axios.post('/api/resource-files', formData).catch(err => {
                            window.Swal.fire({
                                title: "An error occurred!",
                                text: "The file could not be uploaded!",
                                buttons: true,
                            });
                        });
                    }
                    window.location.reload();
                }
            },
            openResourceImageAddModal() {
                $("#openResourceImageAddModal").modal("show");
            },
            fetchData() {
                let params = {
                    // company_id: this.section.company.id,
                    project_id: this.section.project.id,
                    folder_id: 2,
                };

                this.data_loading = true;
                axios.get(route('api.proposal-resource-files.index'), {params}).then(({data}) => {
                    this.resourceFiles = data.data.map(resourceFile => {
                        resourceFile.thumb_url = route('resource-files.show-thumb', {resourceFile: resourceFile.token});
                        resourceFile.is_thumb_loaded = false;
                        resourceFile.id_key = resourceFile.id;
                        return resourceFile;
                    });
                    this.hasOneFile = this.resourceFiles.length > 0;
                    this.pagination = data;
                    this.data_loading = false;
                });
            },
            signatureFooter() {
                Bus.$emit('signature', !this.signatureButton);
            },
            deleteProposal() {
                let self = this;
                Swal.fire({
                    title             : "Are you sure?",
                    text              : "Once deleted, you will not be able to recover this proposal!",
                    icon              : "warning",
                    buttons           : true,
                    showCancelButton  : true,
                    confirmButtonColor: 'red',
                    confirmButtonText : 'I\'m sure!',
                    closeOnConfirm    : true,
                    closeOnCancel     : true,
                }).then(result => {
                    if (result.value) {
                        axios.delete(route('proposal.destroy', self.proposal.id))
                            .then((response) => {
                                if (response.data.status === 'success') {
                                    window.location = '/project/' + response.data.project_id + '/edit';
                                } else {
                                    self.initTempProposal(response.data.proposal);
                                    self.fireErrorToast(response.data.message);
                                }
                            });
                    }
                });
            },
            unlock() {
                let self = this;
                axios.put('/proposal/' + self.proposal.id + '/unlock')
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.fireSuccessToast(response.data.message);
                            window.location.reload();
                        } else {
                            self.fireErrorToast(response.data.message);
                            self.initTempProposal(response.data.proposal);
                        }
                    });
            },
            lock() {
                let self = this;
                axios.put('/proposal/' + self.proposal.id + '/lock')
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.fireSuccessToast(response.data.message);
                            window.location.reload();
                        } else {
                            self.fireErrorToast(response.data.message);
                            self.initTempProposal(response.data.proposal);
                        }
                    });
            },
        }
    }
</script>

<style scoped>
    .reports-frame-style {
        height: 75vh;
        width: 100%;
        border: 1px solid grey;
        border-radius: 7px;
    }
    .resource-images-div {
        float: left;
        padding: 0 5px;
        margin-bottom: 10px;
        height: 145px;
    }
    span.resource-images-name {
        font-size: 10px;
        word-break: break-word;
    }
    .resource-images {
        height: 55px;
    }
    .resource-images-div {
        float: left;
        padding: 0 5px;
        margin-bottom: 10px;
        height: 100px;
    }
    span.resource-images-name {
        font-size: 10px;
        word-break: break-word;
    }
    .resource-images {
        height: 55px;
    }
    .tool-buttons {
        border: 1px solid #01b1af;
        margin: 0 5px;
        font-size: 12px;
        padding: 10px 0;
        color: #01b1af;
        text-align: center;
        margin-bottom: 9px;
        max-width: 45% !important;
        margin-right: 5px;
        margin-left: 7px;
    }
    .tool-buttons:hover {
        background-color: #01b1af1c;
        cursor: pointer;
    }
    .deleteBtn {
        color: #dc3545 !important;
        border-color: #dc3545 !important;
        max-width: 95% !important;
    }
    .deleteBtn:hover{
        background-color: #dc35451c !important;
    }
</style>
